import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "empty no-select" }
const _hoisted_2 = { class: "upload-wrapper" }
const _hoisted_3 = { class: "upload-icon" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_UploadButton = _resolveComponent("UploadButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, {
          draggable: false,
          class: "img",
          icon: "file-type",
          alt: "file-type-icon"
        })
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text" }, " You dont have any files uploaded yet... ", -1 /* HOISTED */)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "sub-text" }, " Here you will find all the files uploaded ", -1 /* HOISTED */)),
      _createVNode(_component_UploadButton, {
        primary: "",
        stroke: "white",
        onUpload: _cache[0] || (_cache[0] = (files) => _ctx.$emit('upload', files))
      })
    ])
  ]))
}